import PostGroup from './post-group'

export default PostGroup



// WEBPACK FOOTER //
// ./src/scenes/feed/post-group/index.js